import React from 'react';
import styles from './DeleteBlockWarningDialog.module.css';
import Dialog, { Banner as DialogBanner } from 'system/base/Dialog';
import { DangerButton, NakedButton } from 'system/base/Button';

export type DeleteBlockWarningDialogProps = {
  isOpen: boolean;
  onConfirm: () => void;
  onDismiss: () => void;
};

export function DeleteBlockWarningDialog({
  isOpen,
  onConfirm,
  onDismiss,
}: DeleteBlockWarningDialogProps) {
  return (
    <Dialog isOpen={isOpen} onDismiss={onDismiss} title="Delete field?">
      <DialogBanner type="error">
        <div>
          <div>Any extracted data will be deleted</div>
        </div>
      </DialogBanner>

      <p>
        You&apos;re about to permanently delete this field and any extracted
        data.
      </p>
      <p>
        <strong>This action cannot be undone.</strong>
      </p>

      <div className={styles.modalFooter}>
        <DangerButton mr={2} onClick={onConfirm}>
          Yes, delete
        </DangerButton>
        <NakedButton onClick={onDismiss}>Cancel</NakedButton>
      </div>
    </Dialog>
  );
}
